import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import noop from 'lodash/noop';
import moment from 'moment';
import Pagination from '../../shared/pagination';

const Table = ({
	table,
	intl,
	sortByColumn,
	showMoreRows,
	toggleAutoArchiving,
	pagination,
	gotoPage,
	can
}) => (
	<div className="table-container campaigns-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								active: table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[table.sortedColumn.direction]:
									table.sortedColumn.index === header.index && table.sortedColumn.direction
							})}
							onClick={() => (header.direction ? sortByColumn(header.index) : noop)}
						>
							{intl(header.title)}
						</th>
					))}
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{table.rows.map((row, i) => (
					<tr key={i}>
						<td className="created-at">
							<span>{moment(row.date).format('DD.MM.YYYY HH:mm:ss.SSS')}</span>
						</td>
						<td className="affiliate">
							<a href={`/affiliates/profile/${row.affiliate_id}`} target="_blank">
								{row.affiliate_email}
							</a>
						</td>
						<td className="url">
							{row.url}
						</td>
						<td className="campaign_id">
							{row.campaign_id}/{row.conversion_id}
						</td>
						<td className="status">
							<span>{row.status}</span>
						</td>
					</tr>
				))}
			</tbody>
		</table>
		<Pagination pagination={pagination} gotoPage={gotoPage} />
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/postback-log/components/table.js